import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#about_batch",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder text-light m-0" }
const _hoisted_5 = { class: "row container my-5" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "list-group" }
const _hoisted_8 = { class: "list-group-item" }
const _hoisted_9 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-secondary float-right"
}
const _hoisted_11 = {
  key: 2,
  class: "badge badge-secondary float-right"
}
const _hoisted_12 = { class: "list-group-item" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_14 = { class: "list-group-item" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_16 = { class: "list-group-item" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_18 = { class: "list-group-item" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_20 = { class: "list-group-item" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = { class: "badge badge-secondary float-right" }
const _hoisted_24 = { class: "list-group-item" }
const _hoisted_25 = { class: "badge badge-secondary float-right" }
const _hoisted_26 = { class: "list-group-item" }
const _hoisted_27 = { class: "badge badge-secondary float-right" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "detail-profile well" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Tranche", -1)
const _hoisted_32 = { class: "col-sm-6" }
const _hoisted_33 = { class: "control-label" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Association", -1)
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = { class: "control-label" }
const _hoisted_38 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "entity",
  "data-search-key": "26",
  title: "",
  "data-original-title": "Training Partner"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Training Institute", -1)
const _hoisted_41 = { class: "col-sm-6" }
const _hoisted_42 = { class: "control-label" }
const _hoisted_43 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "institute",
  "data-search-key": "370",
  title: "",
  "data-original-title": "Training Institute"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Course", -1)
const _hoisted_46 = { class: "col-sm-6" }
const _hoisted_47 = { class: "control-label" }
const _hoisted_48 = {
  href: "javascript:;",
  class: "form_link",
  "data-search-type": "course",
  "data-search-key": "213",
  title: "",
  "data-original-title": "Training Course"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Batch Number", -1)
const _hoisted_51 = { class: "col-sm-6" }
const _hoisted_52 = { class: "control-label" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Training Location", -1)
const _hoisted_55 = { class: "col-sm-6" }
const _hoisted_56 = { class: "control-label" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Participant Capacity", -1)
const _hoisted_59 = { class: "col-sm-6" }
const _hoisted_60 = { class: "control-label" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Start Date (as planned)", -1)
const _hoisted_63 = { class: "col-sm-6" }
const _hoisted_64 = { class: "control-label" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "End Date (as planned)", -1)
const _hoisted_67 = { class: "col-sm-6" }
const _hoisted_68 = { class: "control-label" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Training Start Date", -1)
const _hoisted_71 = { class: "col-sm-6" }
const _hoisted_72 = { class: "control-label" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Training End Date", -1)
const _hoisted_75 = { class: "col-sm-6" }
const _hoisted_76 = { class: "control-label" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Total Training Days", -1)
const _hoisted_79 = { class: "col-sm-6" }
const _hoisted_80 = { class: "control-label" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 control-label text-right" }, "Total Training Hours", -1)
const _hoisted_83 = { class: "col-sm-6" }
const _hoisted_84 = { class: "control-label" }
const _hoisted_85 = { class: "card mb-5 mb-xl-10" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#about_batch",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch Class Schedule")
  ])
], -1)
const _hoisted_87 = { class: "form-group remove_form_padding" }
const _hoisted_88 = { class: "form-group mb-4" }
const _hoisted_89 = { class: "badge badge-primary mr-4" }
const _hoisted_90 = { class: "badge badge-info mr-4" }
const _hoisted_91 = { class: "badge badge-success mr-4" }
const _hoisted_92 = { class: "badge badge-warning mr-4" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_96 = { style: {"border":"1px solid #b5b5c3"} }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("th", null, "Sl", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Days", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("th", null, "Start Time", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("th", null, "End Time", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("th", null, "Daily Hours", -1)
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, "About Batch " + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summary?.total_training_days), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createTextVNode(" Batch Status " + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summary?.total_training_days) + " ", 1),
              (_ctx.batchInfoData?.end_date <= this.today)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Completed"))
                : (
                _ctx.batchInfoData?.start_date <= this.today &&
                _ctx.batchInfoData?.end_date >= this.today
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Running"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, " Upcoming "))
            ]),
            _createElementVNode("li", _hoisted_12, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_enrolled) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_enrolled), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Enrolled/Female ")
            ]),
            _createElementVNode("li", _hoisted_14, [
              (_ctx.batchInfoData.batch_attendance_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.batchInfoData?.batch_attendance_summery?.total_training_days) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summery?.completed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Training Days ")
            ]),
            _createElementVNode("li", _hoisted_16, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_assessed) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_assessed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Assessed/Female ")
            ]),
            _createElementVNode("li", _hoisted_18, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_certified) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_certified), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Certified/Female ")
            ]),
            _createElementVNode("li", _hoisted_20, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_employed) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_employed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Employed/Female ")
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.batchInfoData?.claim_1_batch?.bill_no), 1),
              _createTextVNode(" Claim-1 ")
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.batchInfoData?.claim_2_batch?.bill_no), 1),
              _createTextVNode(" Claim-2 ")
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.batchInfoData?.claim_3_batch?.bill_no), 1),
              _createTextVNode(" Claim-3 ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.batchInfoData?.tranche_info?.label), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.batchInfoData?.entity_info?.entity_short_name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.batchInfoData?.institute_info?.institute_name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("a", _hoisted_48, _toDisplayString(_ctx.batchInfoData?.course_info?.course_name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.batchInfoData?.batch_number), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.batchInfoData?.training_location), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.batchInfoData?.training_capacity), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.batchInfoData?.start_date
                    ? _ctx.moment(_ctx.batchInfoData?.start_date).format('DD-MM-YYYY')
                    : _ctx.batchInfoData?.start_date), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.batchInfoData?.end_date
                    ? _ctx.moment(_ctx.batchInfoData?.end_date).format('DD-MM-YYYY')
                    : _ctx.batchInfoData?.end_date), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.batchInfoData?.start_date
                    ? _ctx.moment(_ctx.batchInfoData?.start_date).format('DD-MM-YYYY')
                    : _ctx.batchInfoData?.start_date), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.batchInfoData?.end_date
                    ? _ctx.moment(_ctx.batchInfoData?.end_date).format('DD-MM-YYYY')
                    : _ctx.batchInfoData?.end_date), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.batchInfoData?.total_training_days), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.batchInfoData?.total_training_hours), 1)
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_85, [
      _hoisted_86,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchInfoData.term_details, (info, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "panel-body container mt-5",
          key: index
        }, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("span", _hoisted_89, [
                _createTextVNode("Term: "),
                _createElementVNode("span", null, _toDisplayString(index), 1)
              ]),
              _createElementVNode("span", _hoisted_90, [
                _createTextVNode("Start Date: "),
                _createElementVNode("span", null, _toDisplayString(info?.start_date
                ? _ctx.moment(info?.start_date).format('DD-MM-YYYY')
                : info?.start_date), 1)
              ]),
              _createElementVNode("span", _hoisted_91, [
                _createTextVNode("End Date: "),
                _createElementVNode("span", null, _toDisplayString(info?.end_date
                  ? _ctx.moment(info?.end_date).format('DD-MM-YYYY')
                  : info?.end_date), 1)
              ]),
              _createElementVNode("span", _hoisted_92, [
                _createTextVNode("Class Type: "),
                (info?.class_type == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_93, "Class Work"))
                  : _createCommentVNode("", true),
                (info?.class_type == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, "Internship"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("table", _hoisted_95, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_96, [
                  _hoisted_97,
                  _hoisted_98,
                  _hoisted_99,
                  _hoisted_100,
                  _hoisted_101,
                  (info?.class_type == 1)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_102, "Lead Trainer"))
                    : _createCommentVNode("", true),
                  (info?.class_type == 1)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_103, "Associate Trainer"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.details, (dinfo, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: dinfo,
                    class: "tr_clone_1 border border-gray-400"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo?.training_day), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo.start_time
                    ? _ctx.moment(dinfo?.start_time, 'hh:mm').format('LT')
                    : 'No time found'), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo.end_time
                    ? _ctx.moment(dinfo?.end_time, 'hh:mm').format('LT')
                    : 'No time found'), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo?.daily_hour), 1),
                    (info?.class_type == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_104, _toDisplayString(dinfo?.master_trainer_info?.employee_info?.name), 1))
                      : _createCommentVNode("", true),
                    (info?.class_type == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_105, _toDisplayString(dinfo?.associate_trainer_info?.employee_info?.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ], 64))
}